import { createIcon } from './create-icon'

export const AI = createIcon({
  displayName: 'AI',
  viewBox: '0 0 24 24',
  paths: [
    'm11.5134 6.06228c.1211-.51356.8521-.51356.9732 0l.8278 3.50791c.1305.55311.5623.98491 1.1154 1.11541l3.5079.8278c.5136.1211.5136.8521 0 .9732l-3.5079.8278c-.5531.1305-.9849.5623-1.1154 1.1154l-.8278 3.5079c-.1211.5136-.8521.5136-.9732 0l-.8278-3.5079c-.1305-.5531-.5623-.9849-1.11541-1.1154l-3.50791-.8278c-.51356-.1211-.51356-.8521 0-.9732l3.50791-.8278c.55311-.1305.98491-.5623 1.11541-1.11541z'
  ]
})
